/**
 * Mutation to update a marketplace_seller_feature record (toggle enabled)
 */
const updateSellerFeatureMutation = `
mutation UpdateSellerFeature($id: ID!, $fields: UpdateMarketplace_seller_featureFieldsInput) {
  updateMarketplace_seller_feature(input: { id: $id, fields: $fields }) {
    marketplace_seller_feature {
      objectId
      enabled
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default updateSellerFeatureMutation;
